import { makeRequest } from '../../../../lib/api';
import { TBankMultiPaymentReportRequest, TBankPartnerLegalRequest } from '../store/tBankreportApi';

const REPORT_LEGAL_PATH = '/v1/partner_legal';
const REPORT_MULTISPLIT_ORDER_PATH = '/v1/order_invoices/payments/multisplit';

class reportController {
  getTBankLegals = (request: TBankPartnerLegalRequest) => {
    const param = request.date ? `?date=${ request.date }`: '';
    return makeRequest('get', `${ REPORT_LEGAL_PATH }/tbank_multisplit${ param }`);
  };

  getMultiPaymentReport = (request: TBankMultiPaymentReportRequest) => {
    // Поля быстрого поиска отправляем только когда они заданы: если задан один
    // из номеров, бэк ищет по нему и игнорирует период.
    // encodeURIComponent обязателен: '+' в номере телефона иначе станет пробелом.
    const searchParams = [
      ['phoneNumber', request?.phoneNumber],
      ['orderNumber', request?.orderNumber],
      ['nikNumber', request?.nikNumber],
    ]
      .filter(([, value]) => !!value)
      .map(([name, value]) => `${ name }=${ encodeURIComponent(value) }`)
      .join('&');

    const params = [
      `sinceDate=${ request?.sinceCreatedDate }`,
      `tillDate=${ request?.tillCreatedDate }`,
      searchParams,
    ].filter(Boolean).join('&');

    return makeRequest('get', `${ REPORT_MULTISPLIT_ORDER_PATH }/report?${ params }`);
  };
}

export default new reportController();
